// HeaderOverflowMenuItems — stateless leaf extracted from ContactEditModal.tsx's
// ··· overflow menu render body. Pure render of props: holds no
// useState/useEffect/useRef of its own. The orchestrator owns the menu-open and
// confirmation state and binds the archive/delete callbacks (each gated on its
// own handler being provided). DOM/markup byte-identical to the inline buttons.
//
// The Delete item was wired in #3505 (previously the delete-confirmation modal
// was dead code — no control ever opened it); both items live here so the
// orchestrator only mounts the menu container.
export function HeaderOverflowMenuItems({
  showArchive,
  showDelete,
  onArchive,
  onDelete,
}: {
  showArchive: boolean;
  showDelete: boolean;
  onArchive: () => void;
  onDelete: () => void;
}) {
  return (
    <>
      {showArchive && (
        <button type="button" onClick={onArchive} style={{
          display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '10px 14px',
          background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#4a4d51',
          fontFamily: 'inherit', textAlign: 'left',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = '#F1F3F4'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'none'; }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 8v13H3V8"/><path d="M1 3h22v5H1z"/><path d="M10 12h4"/>
          </svg>
          Archive
        </button>
      )}
      {showDelete && (
        <button type="button" onClick={onDelete} style={{
          display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '10px 14px',
          background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: 'var(--color-danger)',
          fontFamily: 'inherit', textAlign: 'left',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = '#FCE8E6'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'none'; }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
          </svg>
          Delete
        </button>
      )}
    </>
  );
}
